import Model from 'flarum/common/Model';

export default class CaseInterpretation extends Model {}

Object.assign(CaseInterpretation.prototype, {
  caseId: Model.attribute('case_id'),
  userId: Model.attribute('user_id'),
  isAiGenerated: Model.attribute('is_ai_generated'),
  isLocked: Model.attribute('is_locked'),
  content: Model.attribute('content'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  case: Model.hasOne('case'),
  user: Model.hasOne('user'),
});
